// Two-step verification (Auth.jsx code step, components/TwoFactorSettings.jsx, Users.jsx admin reset)
// and the invite flow for existing accounts.
const strings = {
  es: {
    mfa_title: "Verificación en dos pasos",
    mfa_hint_email: "Enviamos un código de 6 dígitos a {email}. Escríbelo para entrar.",
    mfa_hint_totp: "Abre tu app autenticadora (Google o Microsoft Authenticator) y escribe el código de 6 dígitos de ClinicOS.",
    mfa_code_label: "Código de verificación",
    mfa_code_6: "Escribe los 6 dígitos del código.",
    mfa_verify: "Verificar y entrar",
    mfa_no_code: "¿No te llegó?",
    mfa_resend: "Reenviar código",
    mfa_resend_in: "Reenviar en {s} s",
    mfa_other_account: "Usar otra cuenta",
    mfa_locked_out: "¿Sin acceso a tu correo o teléfono? Pide al administrador que desactive tu verificación en dos pasos.",
    mfa_available_note: "Protege tu cuenta con verificación en dos pasos desde Mi cuenta.",
    tf_title: "Verificación en dos pasos",
    tf_desc: "Además de tu contraseña, te pediremos un código de 6 dígitos al iniciar sesión. Así nadie entra a tu cuenta aunque conozca tu contraseña.",
    tf_on_email: "Activada · correo",
    tf_on_totp: "Activada · app autenticadora",
    tf_off: "Desactivada",
    tf_since: "Activa desde {date}",
    tf_turn_on: "Activar verificación en dos pasos",
    tf_turn_off: "Desactivar",
    tf_choose: "¿Cómo quieres recibir tu código?",
    tf_email_title: "Por correo",
    tf_easiest: "Más fácil",
    tf_email_desc: "Te enviamos un código a {email} cada vez que inicias sesión. No necesitas instalar nada.",
    tf_totp_title: "App autenticadora",
    tf_most_secure: "Más segura",
    tf_totp_desc: "Usa Google Authenticator, Microsoft Authenticator o similar. Funciona sin internet ni correo.",
    tf_email_sent: "Enviamos un código a {email}. Escríbelo para confirmar que recibes nuestros correos.",
    tf_activate: "Activar",
    tf_totp_step1: "Instala Google Authenticator o Microsoft Authenticator en tu teléfono.",
    tf_totp_step2: "En la app, toca «+» y escanea este código QR.",
    tf_totp_step3: "Escribe el código de 6 dígitos que aparece en la app.",
    tf_qr_alt: "Código QR para la app autenticadora",
    tf_manual_key: "¿No puedes escanear? Escribe esta clave en la app:",
    tf_disable_confirm: "Para desactivarla, confirma tu contraseña.",
    tf_enabled_toast: "Verificación en dos pasos activada",
    tf_disabled_toast: "Verificación en dos pasos desactivada",
    tf_admin_disable: "Desactivar verificación en dos pasos",
    tf_admin_disable_q: "¿Desactivar la verificación en dos pasos?",
    tf_admin_disable_desc: "Úsalo si la persona perdió acceso a su correo o teléfono. Podrá entrar solo con su contraseña y volver a activarla desde Mi cuenta.",
    tf_admin_disabled_toast: "Verificación en dos pasos desactivada para el usuario",
    inv_current_password: "Contraseña de tu cuenta",
    inv_joined_login: "Te uniste a la clínica. Inicia sesión para continuar.",
  },
  en: {
    mfa_title: "Two-step verification",
    mfa_hint_email: "We sent a 6-digit code to {email}. Enter it to sign in.",
    mfa_hint_totp: "Open your authenticator app (Google or Microsoft Authenticator) and enter the 6-digit ClinicOS code.",
    mfa_code_label: "Verification code",
    mfa_code_6: "Enter all 6 digits of the code.",
    mfa_verify: "Verify and sign in",
    mfa_no_code: "Didn't get it?",
    mfa_resend: "Resend code",
    mfa_resend_in: "Resend in {s}s",
    mfa_other_account: "Use another account",
    mfa_locked_out: "Lost access to your email or phone? Ask your administrator to turn off your two-step verification.",
    mfa_available_note: "Protect your account with two-step verification from My account.",
    tf_title: "Two-step verification",
    tf_desc: "Besides your password, we'll ask for a 6-digit code when you sign in, so nobody can get in even if they know your password.",
    tf_on_email: "On · email",
    tf_on_totp: "On · authenticator app",
    tf_off: "Off",
    tf_since: "On since {date}",
    tf_turn_on: "Turn on two-step verification",
    tf_turn_off: "Turn off",
    tf_choose: "How do you want to get your code?",
    tf_email_title: "By email",
    tf_easiest: "Easiest",
    tf_email_desc: "We email a code to {email} every time you sign in. Nothing to install.",
    tf_totp_title: "Authenticator app",
    tf_most_secure: "Most secure",
    tf_totp_desc: "Use Google Authenticator, Microsoft Authenticator or similar. Works without internet or email.",
    tf_email_sent: "We sent a code to {email}. Enter it to confirm you receive our emails.",
    tf_activate: "Turn on",
    tf_totp_step1: "Install Google Authenticator or Microsoft Authenticator on your phone.",
    tf_totp_step2: "In the app, tap “+” and scan this QR code.",
    tf_totp_step3: "Enter the 6-digit code shown in the app.",
    tf_qr_alt: "QR code for the authenticator app",
    tf_manual_key: "Can't scan? Type this key into the app:",
    tf_disable_confirm: "Confirm your password to turn it off.",
    tf_enabled_toast: "Two-step verification turned on",
    tf_disabled_toast: "Two-step verification turned off",
    tf_admin_disable: "Turn off two-step verification",
    tf_admin_disable_q: "Turn off two-step verification?",
    tf_admin_disable_desc: "Use this if the person lost access to their email or phone. They'll sign in with just their password and can turn it on again from My account.",
    tf_admin_disabled_toast: "Two-step verification turned off for the user",
    inv_current_password: "Your account password",
    inv_joined_login: "You joined the clinic. Sign in to continue.",
  },
};

export default strings;
